// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tour-composer {
  --tour-bg: #0b0f19;
  --tour-slate: #121826;
  --tour-text: #f8fafc;
  --tour-muted: #94a3b8;
  --tour-border: rgba(255, 255, 255, 0.08);
  --tour-glass: rgba(15, 23, 42, 0.82);
  --tour-primary: var(--brand-primary, #0877bc);
  --tour-in: #34d399;
  --tour-ease: cubic-bezier(0.16, 1, 0.3, 1);
  position: fixed;
  inset: 0;
  z-index: 80;
  display: flex;
  flex-direction: column;
  background:
    radial-gradient(900px 420px at 8% -10%, color-mix(in srgb, var(--tour-primary) 28%, transparent), transparent 58%),
    var(--tour-bg);
  color: var(--tour-text);
  font-family: Outfit, Inter, -apple-system, sans-serif;
}

.tour-composer--light {
  --tour-bg: #f3f5f8;
  --tour-slate: #ffffff;
  --tour-text: #0f172a;
  --tour-muted: #475569;
  --tour-border: rgba(15, 23, 42, 0.08);
  --tour-glass: rgba(255, 255, 255, 0.92);
  --tour-in: #047857;
}

.tour-composer__bar,
.tour-composer__cta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.9rem 1.1rem;
  border-bottom: 1px solid var(--tour-border);
  background: var(--tour-glass);
  backdrop-filter: blur(16px);
}

.tour-composer__cta {
  border-bottom: 0;
  border-top: 1px solid var(--tour-border);
  padding-bottom: calc(0.9rem + env(safe-area-inset-bottom, 0px));
}

.tour-composer__kicker {
  margin: 0;
  font-size: 0.72rem;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--tour-muted);
}

.tour-composer__bar h2 {
  margin: 0.1rem 0 0;
  font-size: 1.2rem;
  letter-spacing: -0.03em;
}

.tour-composer__bar button {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  border: 1px solid var(--tour-border);
  background: transparent;
  color: inherit;
  cursor: pointer;
}

.tour-composer__grid {
  flex: 1 1;
  min-height: 0;
  display: grid;
  grid-template-columns: 1fr;
  overflow: hidden;
}

.tour-composer__setup,
.tour-composer__preview {
  overflow: auto;
  padding: 1rem 1.1rem 1.4rem;
}

.tour-composer__preview {
  display: none;
  border-top: 1px solid var(--tour-border);
  background: color-mix(in srgb, var(--tour-slate) 70%, transparent);
}

.tour-composer__preview.is-open {
  display: block;
  position: absolute;
  inset: 72px 0 72px;
  z-index: 2;
}

.tour-composer__setup h3,
.tour-view h3 {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin: 1.1rem 0 0.45rem;
  font-size: 0.82rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--tour-muted);
}

.tour-field {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  font-size: 0.78rem;
  color: var(--tour-muted);
}

.tour-field input,
.tour-inline input,
.tour-search input,
.tour-guest input {
  min-height: 42px;
  border-radius: 12px;
  border: 1px solid var(--tour-border);
  background: rgba(255, 255, 255, 0.04);
  color: inherit;
  padding: 0 0.8rem;
  font: inherit;
}

.tour-composer--light .tour-field input,
.tour-composer--light .tour-inline input,
.tour-composer--light .tour-search input,
.tour-composer--light .tour-guest input {
  background: #fff;
}

.tour-chips,
.tour-people__cats,
.tour-view__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
}

.tour-chips button,
.tour-people__cats button,
.tour-view__chips button {
  min-height: 34px;
  border-radius: 999px;
  border: 1px solid var(--tour-border);
  background: transparent;
  color: inherit;
  padding: 0.25rem 0.75rem;
  font: inherit;
  font-size: 0.82rem;
  font-weight: 650;
  cursor: pointer;
  transition: transform 0.25s var(--tour-ease), background 0.2s ease;
}

.tour-chips button.is-on,
.tour-people__cats button.is-on,
.tour-view__chips button.is-on {
  background: color-mix(in srgb, var(--tour-primary) 22%, transparent);
  border-color: color-mix(in srgb, var(--tour-primary) 50%, transparent);
}

.tour-chips button:active,
.tour-composer__go:active {
  transform: scale(0.97);
}

.tour-inline,
.tour-search,
.tour-guest,
.tour-stepper {
  display: flex;
  gap: 0.45rem;
  align-items: center;
  margin-top: 0.45rem;
}

.tour-inline button,
.tour-guest button,
.tour-stepper button,
.tour-clublist button,
.tour-hits button {
  min-height: 36px;
  border-radius: 10px;
  border: 1px solid var(--tour-border);
  background: rgba(255, 255, 255, 0.04);
  color: inherit;
  cursor: pointer;
  font: inherit;
}

.tour-search {
  position: relative;
  padding-left: 0.2rem;
}

.tour-search svg:first-child {
  flex-shrink: 0;
  opacity: 0.7;
}

.tour-search input {
  flex: 1 1;
}

.tour-hint,
.tour-view__hint,
.tour-view__headline {
  margin: 0.2rem 0 0.55rem;
  color: var(--tour-muted);
  font-size: 0.88rem;
  line-height: 1.45;
}

.tour-view__headline {
  color: inherit;
  font-weight: 650;
}

.tour-view__warn,
.tour-error {
  color: #fb7185;
  font-size: 0.85rem;
}

.tour-cat-list,
.tour-hits,
.tour-people,
.tour-clublist ul,
.tour-view__finals {
  list-style: none;
  margin: 0.5rem 0 0;
  padding: 0;
}

.tour-cat-list li,
.tour-people li,
.tour-view__pools li,
.tour-view__tables li,
.tour-view__finals li {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  padding: 0.45rem 0;
}

.tour-hits button,
.tour-clublist button {
  width: 100%;
  text-align: left;
  padding: 0.45rem 0.65rem;
}

.tour-hits strong,
.tour-people strong,
.tour-view strong {
  display: block;
}

.tour-hits em,
.tour-people em,
.tour-view em {
  color: var(--tour-muted);
  font-style: normal;
  font-size: 0.78rem;
}

.tour-ava {
  width: 34px;
  height: 34px;
  border-radius: 11px;
  display: grid;
  place-items: center;
  background: color-mix(in srgb, var(--tour-primary) 18%, transparent);
  font-size: 0.7rem;
  font-weight: 800;
  flex-shrink: 0;
}

.tour-people {
  margin-top: 0.75rem;
}

.tour-people li,
.tour-view__pools article,
.tour-view__tables article,
.tour-view__presence {
  border: 1px solid var(--tour-border);
  border-radius: 16px;
  background: var(--tour-glass);
  padding: 0.7rem 0.8rem;
  margin-bottom: 0.5rem;
}

.tour-people__who {
  min-width: 0;
  flex: 1 1;
}

.tour-people__rm {
  background: transparent;
  border: 0;
  color: var(--tour-muted);
  cursor: pointer;
}

.tour-clublist {
  margin-top: 0.7rem;
  font-size: 0.9rem;
}

.tour-clublist ul {
  max-height: 180px;
  overflow: auto;
}

.tour-nums {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.8rem;
}

.tour-stepper strong {
  min-width: 1.6rem;
  text-align: center;
  font-size: 1.15rem;
}

.tour-composer__go,
.tour-composer__ghost,
.tour-view__presence-acts button {
  min-height: 44px;
  border-radius: 999px;
  border: 1px solid var(--tour-border);
  padding: 0 1.1rem;
  font: inherit;
  font-weight: 750;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
}

.tour-composer__go {
  background: var(--tour-primary);
  color: #fff;
  border-color: transparent;
}

.tour-composer__go:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.tour-composer__ghost {
  background: transparent;
  color: inherit;
}

.tour-spin {
  animation: tour-spin 0.8s linear infinite;
}

@keyframes tour-spin {
  to {
    transform: rotate(360deg);
  }
}

.tour-view__pools,
.tour-view__tables {
  display: grid;
  gap: 0.65rem;
}

.tour-view__pools header,
.tour-view__tables header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.35rem;
  font-size: 0.85rem;
}

.tour-view__slot {
  font-size: 0.72rem;
  font-weight: 800;
  color: var(--tour-primary);
  min-width: 2rem;
}

.tour-view__presence-acts {
  display: flex;
  gap: 0.45rem;
  margin-top: 0.55rem;
}

.tour-view__presence-acts .is-in {
  background: rgba(52, 211, 153, 0.18);
  color: var(--tour-in);
}

.tour-view__presence-acts .is-out {
  background: rgba(251, 113, 133, 0.14);
  color: #fb7185;
}

.tour-overlay {
  position: fixed;
  inset: 0;
  z-index: 70;
  background: var(--tour-bg, #0b0f19);
  color: var(--tour-text, #f8fafc);
  overflow: auto;
  padding: 1rem 1.1rem calc(90px + env(safe-area-inset-bottom, 0px));
  font-family: Outfit, Inter, -apple-system, sans-serif;
}

.tour-overlay__bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.8rem;
}

.tour-overlay__bar h2 {
  margin: 0;
  font-size: 1.35rem;
  letter-spacing: -0.03em;
}

.tour-overlay__bar button {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  border: 1px solid var(--tour-border, rgba(255, 255, 255, 0.08));
  background: transparent;
  color: inherit;
  cursor: pointer;
}

@media (min-width: 960px) {
  .tour-composer__grid {
    grid-template-columns: minmax(320px, 0.95fr) minmax(340px, 1.05fr);
  }

  .tour-composer__preview {
    display: block;
    border-top: 0;
    border-left: 1px solid var(--tour-border);
    position: static;
  }

  .tour-composer__ghost {
    display: none;
  }

  .tour-view__pools,
  .tour-view__tables {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.tour-composer__secondary {
  border: 1px solid var(--tour-border);
  background: transparent;
  color: var(--tour-text);
  border-radius: 999px;
  padding: 0.7rem 1rem;
  font: inherit;
  cursor: pointer;
}

.tour-score-actions {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  margin-top: 0.4rem;
}

.tour-score-actions__live,
.tour-score-actions__photo {
  align-self: flex-start;
  font: inherit;
  font-size: 0.82rem;
  padding: 0.35rem 0.65rem;
  border-radius: 6px;
  border: 1px solid var(--tour-border);
  background: color-mix(in srgb, var(--tour-primary) 18%, transparent);
  color: inherit;
  cursor: pointer;
}

.tour-score-actions__photo {
  display: inline-flex;
  align-items: center;
}

.tour-score-actions__photo input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  overflow: hidden;
}

.tour-score-actions__photo.is-busy {
  opacity: 0.7;
}

.tour-score-actions__err {
  margin: 0;
  color: #f87171;
  font-size: 0.8rem;
}

.tour-score-actions__hint {
  margin: 0;
  color: var(--tour-muted);
  font-size: 0.8rem;
}

.tour-score {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  margin-top: 0.35rem;
  align-items: center;
}

.tour-score__game {
  display: inline-flex;
  gap: 0.2rem;
}

.tour-score input {
  width: 2.6rem;
  padding: 0.25rem;
  border-radius: 6px;
  border: 1px solid var(--tour-border);
  background: transparent;
  color: inherit;
  font: inherit;
}

.tour-field input[type="date"],
.tour-field input[type="time"],
.tour-field input[type="datetime-local"] {
  color-scheme: dark;
}

.tour-composer--light .tour-field input[type="date"],
.tour-composer--light .tour-field input[type="time"],
.tour-composer--light .tour-field input[type="datetime-local"] {
  color-scheme: light;
}

.tour-chips button:focus-visible,
.tour-composer__go:focus-visible,
.tour-composer__bar button:focus-visible,
.tour-people__cats button:focus-visible {
  outline: 2px solid var(--tour-primary);
  outline-offset: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/common/TournamentSetupComposer.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,wCAAwC;EACxC,oCAAoC;EACpC,6CAA6C;EAC7C,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;EACf,QAAQ;EACR,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB;;kBAEgB;EAChB,uBAAuB;EACvB,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,qCAAqC;EACrC,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB;EACtB,2CAA2C;EAC3C,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,+DAA+D;AACjE;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,kEAAkE;AACpE;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;;;;EAIE,gBAAgB;EAChB,mBAAmB;EACnB,oCAAoC;EACpC,qCAAqC;EACrC,cAAc;EACd,iBAAiB;EACjB,aAAa;AACf;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;;;EAGE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;;;EAGE,gBAAgB;EAChB,oBAAoB;EACpB,oCAAoC;EACpC,uBAAuB;EACvB,cAAc;EACd,wBAAwB;EACxB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kEAAkE;AACpE;;AAEA;;;EAGE,oEAAoE;EACpE,sEAAsE;AACxE;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;;;EAIE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;;;;EAKE,gBAAgB;EAChB,mBAAmB;EACnB,oCAAoC;EACpC,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,SAAO;AACT;;AAEA;;;EAGE,wBAAwB;EACxB,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,kBAAkB;AACpB;;AAEA;;;;;EAKE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;;;;EAKE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;EAGE,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,oEAAoE;EACpE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;EAIE,oCAAoC;EACpC,mBAAmB;EACnB,6BAA6B;EAC7B,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;;EAGE,gBAAgB;EAChB,oBAAoB;EACpB,oCAAoC;EACpC,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;;EAEE,aAAa;EACb,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,mCAAmC;EACnC,gCAAgC;EAChC,cAAc;EACd,kEAAkE;EAClE,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+DAA+D;EAC/D,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,kEAAkE;EACpE;;EAEA;IACE,cAAc;IACd,aAAa;IACb,yCAAyC;IACzC,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,gDAAgD;EAClD;AACF;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,uBAAuB;EACvB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,oCAAoC;EACpC,oEAAoE;EACpE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,uBAAuB;EACvB,cAAc;EACd,aAAa;AACf;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;;;EAIE,sCAAsC;EACtC,mBAAmB;AACrB","sourcesContent":[".tour-composer {\n  --tour-bg: #0b0f19;\n  --tour-slate: #121826;\n  --tour-text: #f8fafc;\n  --tour-muted: #94a3b8;\n  --tour-border: rgba(255, 255, 255, 0.08);\n  --tour-glass: rgba(15, 23, 42, 0.82);\n  --tour-primary: var(--brand-primary, #0877bc);\n  --tour-in: #34d399;\n  --tour-ease: cubic-bezier(0.16, 1, 0.3, 1);\n  position: fixed;\n  inset: 0;\n  z-index: 80;\n  display: flex;\n  flex-direction: column;\n  background:\n    radial-gradient(900px 420px at 8% -10%, color-mix(in srgb, var(--tour-primary) 28%, transparent), transparent 58%),\n    var(--tour-bg);\n  color: var(--tour-text);\n  font-family: Outfit, Inter, -apple-system, sans-serif;\n}\n\n.tour-composer--light {\n  --tour-bg: #f3f5f8;\n  --tour-slate: #ffffff;\n  --tour-text: #0f172a;\n  --tour-muted: #475569;\n  --tour-border: rgba(15, 23, 42, 0.08);\n  --tour-glass: rgba(255, 255, 255, 0.92);\n  --tour-in: #047857;\n}\n\n.tour-composer__bar,\n.tour-composer__cta {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 0.9rem 1.1rem;\n  border-bottom: 1px solid var(--tour-border);\n  background: var(--tour-glass);\n  backdrop-filter: blur(16px);\n}\n\n.tour-composer__cta {\n  border-bottom: 0;\n  border-top: 1px solid var(--tour-border);\n  padding-bottom: calc(0.9rem + env(safe-area-inset-bottom, 0px));\n}\n\n.tour-composer__kicker {\n  margin: 0;\n  font-size: 0.72rem;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--tour-muted);\n}\n\n.tour-composer__bar h2 {\n  margin: 0.1rem 0 0;\n  font-size: 1.2rem;\n  letter-spacing: -0.03em;\n}\n\n.tour-composer__bar button {\n  width: 40px;\n  height: 40px;\n  border-radius: 12px;\n  border: 1px solid var(--tour-border);\n  background: transparent;\n  color: inherit;\n  cursor: pointer;\n}\n\n.tour-composer__grid {\n  flex: 1;\n  min-height: 0;\n  display: grid;\n  grid-template-columns: 1fr;\n  overflow: hidden;\n}\n\n.tour-composer__setup,\n.tour-composer__preview {\n  overflow: auto;\n  padding: 1rem 1.1rem 1.4rem;\n}\n\n.tour-composer__preview {\n  display: none;\n  border-top: 1px solid var(--tour-border);\n  background: color-mix(in srgb, var(--tour-slate) 70%, transparent);\n}\n\n.tour-composer__preview.is-open {\n  display: block;\n  position: absolute;\n  inset: 72px 0 72px;\n  z-index: 2;\n}\n\n.tour-composer__setup h3,\n.tour-view h3 {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  margin: 1.1rem 0 0.45rem;\n  font-size: 0.82rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--tour-muted);\n}\n\n.tour-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  font-size: 0.78rem;\n  color: var(--tour-muted);\n}\n\n.tour-field input,\n.tour-inline input,\n.tour-search input,\n.tour-guest input {\n  min-height: 42px;\n  border-radius: 12px;\n  border: 1px solid var(--tour-border);\n  background: rgba(255, 255, 255, 0.04);\n  color: inherit;\n  padding: 0 0.8rem;\n  font: inherit;\n}\n\n.tour-composer--light .tour-field input,\n.tour-composer--light .tour-inline input,\n.tour-composer--light .tour-search input,\n.tour-composer--light .tour-guest input {\n  background: #fff;\n}\n\n.tour-chips,\n.tour-people__cats,\n.tour-view__chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n}\n\n.tour-chips button,\n.tour-people__cats button,\n.tour-view__chips button {\n  min-height: 34px;\n  border-radius: 999px;\n  border: 1px solid var(--tour-border);\n  background: transparent;\n  color: inherit;\n  padding: 0.25rem 0.75rem;\n  font: inherit;\n  font-size: 0.82rem;\n  font-weight: 650;\n  cursor: pointer;\n  transition: transform 0.25s var(--tour-ease), background 0.2s ease;\n}\n\n.tour-chips button.is-on,\n.tour-people__cats button.is-on,\n.tour-view__chips button.is-on {\n  background: color-mix(in srgb, var(--tour-primary) 22%, transparent);\n  border-color: color-mix(in srgb, var(--tour-primary) 50%, transparent);\n}\n\n.tour-chips button:active,\n.tour-composer__go:active {\n  transform: scale(0.97);\n}\n\n.tour-inline,\n.tour-search,\n.tour-guest,\n.tour-stepper {\n  display: flex;\n  gap: 0.45rem;\n  align-items: center;\n  margin-top: 0.45rem;\n}\n\n.tour-inline button,\n.tour-guest button,\n.tour-stepper button,\n.tour-clublist button,\n.tour-hits button {\n  min-height: 36px;\n  border-radius: 10px;\n  border: 1px solid var(--tour-border);\n  background: rgba(255, 255, 255, 0.04);\n  color: inherit;\n  cursor: pointer;\n  font: inherit;\n}\n\n.tour-search {\n  position: relative;\n  padding-left: 0.2rem;\n}\n\n.tour-search svg:first-child {\n  flex-shrink: 0;\n  opacity: 0.7;\n}\n\n.tour-search input {\n  flex: 1;\n}\n\n.tour-hint,\n.tour-view__hint,\n.tour-view__headline {\n  margin: 0.2rem 0 0.55rem;\n  color: var(--tour-muted);\n  font-size: 0.88rem;\n  line-height: 1.45;\n}\n\n.tour-view__headline {\n  color: inherit;\n  font-weight: 650;\n}\n\n.tour-view__warn,\n.tour-error {\n  color: #fb7185;\n  font-size: 0.85rem;\n}\n\n.tour-cat-list,\n.tour-hits,\n.tour-people,\n.tour-clublist ul,\n.tour-view__finals {\n  list-style: none;\n  margin: 0.5rem 0 0;\n  padding: 0;\n}\n\n.tour-cat-list li,\n.tour-people li,\n.tour-view__pools li,\n.tour-view__tables li,\n.tour-view__finals li {\n  display: flex;\n  align-items: center;\n  gap: 0.55rem;\n  padding: 0.45rem 0;\n}\n\n.tour-hits button,\n.tour-clublist button {\n  width: 100%;\n  text-align: left;\n  padding: 0.45rem 0.65rem;\n}\n\n.tour-hits strong,\n.tour-people strong,\n.tour-view strong {\n  display: block;\n}\n\n.tour-hits em,\n.tour-people em,\n.tour-view em {\n  color: var(--tour-muted);\n  font-style: normal;\n  font-size: 0.78rem;\n}\n\n.tour-ava {\n  width: 34px;\n  height: 34px;\n  border-radius: 11px;\n  display: grid;\n  place-items: center;\n  background: color-mix(in srgb, var(--tour-primary) 18%, transparent);\n  font-size: 0.7rem;\n  font-weight: 800;\n  flex-shrink: 0;\n}\n\n.tour-people {\n  margin-top: 0.75rem;\n}\n\n.tour-people li,\n.tour-view__pools article,\n.tour-view__tables article,\n.tour-view__presence {\n  border: 1px solid var(--tour-border);\n  border-radius: 16px;\n  background: var(--tour-glass);\n  padding: 0.7rem 0.8rem;\n  margin-bottom: 0.5rem;\n}\n\n.tour-people__who {\n  min-width: 0;\n  flex: 1;\n}\n\n.tour-people__rm {\n  background: transparent;\n  border: 0;\n  color: var(--tour-muted);\n  cursor: pointer;\n}\n\n.tour-clublist {\n  margin-top: 0.7rem;\n  font-size: 0.9rem;\n}\n\n.tour-clublist ul {\n  max-height: 180px;\n  overflow: auto;\n}\n\n.tour-nums {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.8rem;\n}\n\n.tour-stepper strong {\n  min-width: 1.6rem;\n  text-align: center;\n  font-size: 1.15rem;\n}\n\n.tour-composer__go,\n.tour-composer__ghost,\n.tour-view__presence-acts button {\n  min-height: 44px;\n  border-radius: 999px;\n  border: 1px solid var(--tour-border);\n  padding: 0 1.1rem;\n  font: inherit;\n  font-weight: 750;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n.tour-composer__go {\n  background: var(--tour-primary);\n  color: #fff;\n  border-color: transparent;\n}\n\n.tour-composer__go:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.tour-composer__ghost {\n  background: transparent;\n  color: inherit;\n}\n\n.tour-spin {\n  animation: tour-spin 0.8s linear infinite;\n}\n\n@keyframes tour-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.tour-view__pools,\n.tour-view__tables {\n  display: grid;\n  gap: 0.65rem;\n}\n\n.tour-view__pools header,\n.tour-view__tables header {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 0.35rem;\n  font-size: 0.85rem;\n}\n\n.tour-view__slot {\n  font-size: 0.72rem;\n  font-weight: 800;\n  color: var(--tour-primary);\n  min-width: 2rem;\n}\n\n.tour-view__presence-acts {\n  display: flex;\n  gap: 0.45rem;\n  margin-top: 0.55rem;\n}\n\n.tour-view__presence-acts .is-in {\n  background: rgba(52, 211, 153, 0.18);\n  color: var(--tour-in);\n}\n\n.tour-view__presence-acts .is-out {\n  background: rgba(251, 113, 133, 0.14);\n  color: #fb7185;\n}\n\n.tour-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 70;\n  background: var(--tour-bg, #0b0f19);\n  color: var(--tour-text, #f8fafc);\n  overflow: auto;\n  padding: 1rem 1.1rem calc(90px + env(safe-area-inset-bottom, 0px));\n  font-family: Outfit, Inter, -apple-system, sans-serif;\n}\n\n.tour-overlay__bar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 0.75rem;\n  margin-bottom: 0.8rem;\n}\n\n.tour-overlay__bar h2 {\n  margin: 0;\n  font-size: 1.35rem;\n  letter-spacing: -0.03em;\n}\n\n.tour-overlay__bar button {\n  width: 40px;\n  height: 40px;\n  border-radius: 12px;\n  border: 1px solid var(--tour-border, rgba(255, 255, 255, 0.08));\n  background: transparent;\n  color: inherit;\n  cursor: pointer;\n}\n\n@media (min-width: 960px) {\n  .tour-composer__grid {\n    grid-template-columns: minmax(320px, 0.95fr) minmax(340px, 1.05fr);\n  }\n\n  .tour-composer__preview {\n    display: block;\n    border-top: 0;\n    border-left: 1px solid var(--tour-border);\n    position: static;\n  }\n\n  .tour-composer__ghost {\n    display: none;\n  }\n\n  .tour-view__pools,\n  .tour-view__tables {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n.tour-composer__secondary {\n  border: 1px solid var(--tour-border);\n  background: transparent;\n  color: var(--tour-text);\n  border-radius: 999px;\n  padding: 0.7rem 1rem;\n  font: inherit;\n  cursor: pointer;\n}\n\n.tour-score-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  margin-top: 0.4rem;\n}\n\n.tour-score-actions__live,\n.tour-score-actions__photo {\n  align-self: flex-start;\n  font: inherit;\n  font-size: 0.82rem;\n  padding: 0.35rem 0.65rem;\n  border-radius: 6px;\n  border: 1px solid var(--tour-border);\n  background: color-mix(in srgb, var(--tour-primary) 18%, transparent);\n  color: inherit;\n  cursor: pointer;\n}\n\n.tour-score-actions__photo {\n  display: inline-flex;\n  align-items: center;\n}\n\n.tour-score-actions__photo input {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  opacity: 0;\n  overflow: hidden;\n}\n\n.tour-score-actions__photo.is-busy {\n  opacity: 0.7;\n}\n\n.tour-score-actions__err {\n  margin: 0;\n  color: #f87171;\n  font-size: 0.8rem;\n}\n\n.tour-score-actions__hint {\n  margin: 0;\n  color: var(--tour-muted);\n  font-size: 0.8rem;\n}\n\n.tour-score {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n  margin-top: 0.35rem;\n  align-items: center;\n}\n\n.tour-score__game {\n  display: inline-flex;\n  gap: 0.2rem;\n}\n\n.tour-score input {\n  width: 2.6rem;\n  padding: 0.25rem;\n  border-radius: 6px;\n  border: 1px solid var(--tour-border);\n  background: transparent;\n  color: inherit;\n  font: inherit;\n}\n\n.tour-field input[type=\"date\"],\n.tour-field input[type=\"time\"],\n.tour-field input[type=\"datetime-local\"] {\n  color-scheme: dark;\n}\n\n.tour-composer--light .tour-field input[type=\"date\"],\n.tour-composer--light .tour-field input[type=\"time\"],\n.tour-composer--light .tour-field input[type=\"datetime-local\"] {\n  color-scheme: light;\n}\n\n.tour-chips button:focus-visible,\n.tour-composer__go:focus-visible,\n.tour-composer__bar button:focus-visible,\n.tour-people__cats button:focus-visible {\n  outline: 2px solid var(--tour-primary);\n  outline-offset: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
